import React, { useEffect, useState } from "react";
import MUIRichTextEditor from "mui-rte";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import { createMuiTheme, Grid, MuiThemeProvider } from "@material-ui/core";
import { stateToHTML } from "draft-js-export-html";
import "draft-js/dist/Draft.css";

const editorTheme = createMuiTheme();

Object.assign(editorTheme, {
  overrides: {
    MUIRichTextEditor: {
      root: {
        marginTop: 0,
        border: "1px solid #cccccc",
        borderRadius: "4px",
        height: 350,
        padding: "0 15px",
        overflowY: "scroll",
        overflowX: "hidden",
      },
      editorContainer: {
        minHeight: "350px",
        width: "100%",
      },
    },
  },
});

function Editor(props) {
  const { defaultValue, getData } = props;

  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );
  const [defaultContent, setDefaultContent] = useState("");

  useEffect(() => {
    if (defaultValue.length > 0) {
      const contentHTML = convertFromHTML(defaultValue);
      const state = ContentState.createFromBlockArray(
        contentHTML.contentBlocks,
        contentHTML.entityMap
      );

      setDefaultContent(JSON.stringify(convertToRaw(state)));
      setEditorState(EditorState.createWithContent(state));
    }
  }, [defaultValue]);

  const change = (state) => {
    const html = stateToHTML(state.getCurrentContent());
    getData(html);
  };

  return (
    <Grid container>
      <Grid item lg={12}>
        <div className="title-bar">
          <h3>درباره من</h3>
        </div>
        <br />
        <MuiThemeProvider theme={editorTheme}>
          <MUIRichTextEditor
            className="editor"
            defaultValue={defaultContent}
            editorState={editorState}
            onChange={change}
          />
        </MuiThemeProvider>
      </Grid>
    </Grid>
  );
}

export default React.memo(Editor);
